<!--
空白页 用户授权后来到此页，保存 code, openid, unionid 到state
当用户 进行'点赞' '付款' 等操作 才去绑定个人信息页
 -->
<script>
import { WXlogin } from '@/utils/WXlogin'
import { setLocalStore, getLocalStore } from '@/utils'

export default {
  name: 'BackPage',
  async created() {
    const wxInfo = this.$route.query
    if (wxInfo.code) {
      // 判断用户是否注册
      // eslint-disable-next-line eqeqeq
      if (wxInfo.code == 'bind') {
        this.$router.push({ path: ('/register'), query: { id: wxInfo.unionid, openid: wxInfo.openid }})
        return
      }
      // eslint-disable-next-line eqeqeq
      if (wxInfo.code == 'success') {
        const parame = {
          userLoginType: 'TEL_OPENID',
          openId: wxInfo.openid
        }
        try {
          await this.USER_LOGIN_H5(parame)
        } catch (e) {
          console.log(e)
        }
        return
      }
    }
    // 微信扫一扫入口
    if (wxInfo.deviceCode !== undefined && wxInfo.deviceCode !== null && JSON.stringify(wxInfo.deviceCode) !== '{}' && getLocalStore('userinfo')) {
      setLocalStore('deviceCode', wxInfo.deviceCode)
      console.log(wxInfo.deviceCode + '扫一扫入口')
      this.$router.push({ path: '/', query: { deviceCode: wxInfo.deviceCode }})
      return
    }
    WXlogin()
  },
  methods: {
    // 用户登录
    USER_LOGIN_H5(parame) {
      return new Promise((resolve, reject) => {
        this.$api('USER_LOGIN_H5', parame).then((res) => {
          if (res.code === 200) {
            setLocalStore('userInfo', res.result)
            // wangsh 7-2
            if (JSON.stringify(getLocalStore('deviceCode')) !== '{}' && getLocalStore('deviceCode') !== undefined) {
              this.$router.push({ path: '/', query: { deviceCode: getLocalStore('deviceCode') }})
              return
            }
            this.$router.push({ path: localStorage.getItem('redirect') || '/' })
            resolve()
            return
          }
          this.$toast(res.msg)
        }).catch(err => {
          reject(err)
        })
      })
    },
    // 提交编辑信息
    EQUIPMENT_INFO(deviceCode) {
      return new Promise((resolve, reject) => {
        this.$api('EQUIPMENT_INFO', {
          deviceCode
        }).then((res) => {
          console.log('进入主页')
          this.$router.push({ path: '/', query: { list: res.result }})
          resolve()
        })
      })
    }
  }
}
</script>
